import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';

import { EValidityStatus, TPaymentSumValidity } from '~/src/features/payments-abn/store/actionCreators';
import { toCurrency } from '~/src/helpers/numbers';

/**
 * Возвращает текст ошибки для введенной суммы платежа
 */
export const getInputSumErrorMessage = (paymentSumValidity: TPaymentSumValidity) :string => {
    const baseText = 'Сумма платежа должна быть';

    switch (paymentSumValidity.isValid) {
        case EValidityStatus.IS_LOWER_BOUND_ERROR:
            return `${baseText} не меньше ${toCurrency(paymentSumValidity.minPaymentSum)}${NBSP}${RubleSymbol}`;
        case EValidityStatus.IS_UPPER_BOUND_ERROR:
            return `${baseText} не больше ${toCurrency(paymentSumValidity.maxPaymentSum)}${NBSP}${RubleSymbol}`;
        case EValidityStatus.IS_VALID:
        default:
            return '';
    }
};
